const parseIndiaDate = (value) => {
  if (!value) return null;
  if (value instanceof Date) return value;

  const raw = String(value).trim();
  const normalized = raw.replace(/ /g, "T");

  // Already has timezone info — parse as-is
  if (/Z|[+-]\d{2}:?\d{2}$/.test(normalized)) {
    const parsed = new Date(normalized);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  // No timezone info — treat as IST (UTC+05:30)
  const match = normalized.match(
    /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?$/,
  );
  if (!match) {
    const parsed = new Date(normalized);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  const [, year, month, day, hour, minute, second = "00"] = match;
  const utcMs =
    Date.UTC(
      Number(year),
      Number(month) - 1,
      Number(day),
      Number(hour),
      Number(minute),
      Number(second),
    ) - 5.5 * 60 * 60 * 1000;
  return new Date(utcMs);
};

function formatCustomDate(inputDate) {
  const date = parseIndiaDate(inputDate);
  if (!date || Number.isNaN(date.getTime())) return String(inputDate || "");

  const fmt = new Intl.DateTimeFormat("en-US", {
    timeZone: "Asia/Kolkata",
    day: "numeric",
    month: "short",
    year: "numeric",
  });
  const parts = Object.fromEntries(
    fmt.formatToParts(date).map((p) => [p.type, p.value]),
  );

  return `${parts.month}, ${parts.day}. ${parts.year}`;
}

export default formatCustomDate;
